import React from 'react';

/**
 * Mini-schémas SVG pour illustrer chaque pré-requis en cours voiture.
 * Format : 480x260, palette dark, style éditorial épuré.
 * Chaque schéma est fait pour être projeté à l'élève et servir de support d'échange.
 */

const bg = '#0a0a0b';

export function VisualMecanique() {
  return (
    <svg viewBox="0 0 480 260" className="w-full h-auto" role="img" aria-label="Tableau de bord — familles de voyants">
      <rect width="480" height="260" fill={bg} />
      <rect x="40" y="55" width="400" height="150" rx="14" fill="#151517" stroke="#2a2a2e" strokeWidth="1.5" />
      <text x="240" y="42" textAnchor="middle" fill="#dc2626" fontSize="10" fontFamily="ui-monospace" letterSpacing="2">TABLEAU DE BORD · 3 FAMILLES DE VOYANTS</text>
      {/* Rouge = arrêt */}
      <g transform="translate(90, 100)">
        <circle r="28" fill="#dc2626" opacity="0.15" stroke="#dc2626" strokeWidth="2" />
        <text y="6" textAnchor="middle" fill="#dc2626" fontSize="24" fontWeight="bold">!</text>
        <text y="58" textAnchor="middle" fill="#f87171" fontSize="10" fontWeight="bold" fontFamily="ui-monospace">ROUGE</text>
        <text y="74" textAnchor="middle" fill="#ffffff90" fontSize="9">Arrêt immédiat</text>
      </g>
      {/* Orange = intervention */}
      <g transform="translate(240, 100)">
        <circle r="28" fill="#f59e0b" opacity="0.15" stroke="#f59e0b" strokeWidth="2" />
        <path d="M-10,-6 L0,-14 L10,-6 M0,-14 L0,10" stroke="#f59e0b" strokeWidth="3" fill="none" strokeLinecap="round" />
        <text y="58" textAnchor="middle" fill="#fbbf24" fontSize="10" fontWeight="bold" fontFamily="ui-monospace">ORANGE</text>
        <text y="74" textAnchor="middle" fill="#ffffff90" fontSize="9">Intervention rapide</text>
      </g>
      {/* Vert = info */}
      <g transform="translate(390, 100)">
        <circle r="28" fill="#10b981" opacity="0.15" stroke="#10b981" strokeWidth="2" />
        <path d="M-8,0 L-2,6 L10,-6" stroke="#10b981" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <text y="58" textAnchor="middle" fill="#34d399" fontSize="10" fontWeight="bold" fontFamily="ui-monospace">VERT / BLEU</text>
        <text y="74" textAnchor="middle" fill="#ffffff90" fontSize="9">Information</text>
      </g>
    </svg>
  );
}

export function VisualSynchronisation() {
  return (
    <svg viewBox="0 0 480 260" className="w-full h-auto" role="img" aria-label="Coordination pieds-mains lors du démarrage">
      <rect width="480" height="260" fill={bg} />
      <text x="240" y="30" textAnchor="middle" fill="#f59e0b" fontSize="10" fontFamily="ui-monospace" letterSpacing="2">EMBRAYAGE · POINT DE PATINAGE</text>
      {/* Pédales */}
      <g transform="translate(60, 100)">
        <rect x="0" y="0" width="90" height="130" rx="10" fill="#151517" stroke="#2a2a2e" />
        <rect x="15" y="70" width="20" height="50" rx="3" fill="#f59e0b" opacity="0.85" />
        <rect x="40" y="60" width="15" height="60" rx="3" fill="#3f3f46" />
        <rect x="62" y="45" width="15" height="75" rx="3" fill="#3f3f46" />
        <text x="24" y="145" textAnchor="middle" fill="#fbbf24" fontSize="9" fontFamily="ui-monospace">EMBR</text>
        <text x="46" y="145" textAnchor="middle" fill="#a1a1aa" fontSize="8">Frein</text>
        <text x="68" y="145" textAnchor="middle" fill="#a1a1aa" fontSize="8">Acc</text>
      </g>
      {/* Timeline synchronisation */}
      <g transform="translate(180, 100)">
        <line x1="0" y1="65" x2="260" y2="65" stroke="#3f3f46" strokeWidth="2" />
        {[{x:10, l:'Débraye'}, {x:80, l:'Passe rapport'}, {x:150, l:'Point patinage'}, {x:230, l:'Accélère'}].map((p, i) => (
          <g key={i} transform={`translate(${p.x}, 0)`}>
            <circle cx="0" cy="65" r="7" fill="#f59e0b" />
            <text x="0" y="55" textAnchor="middle" fill="#ffffff" fontSize="9" fontFamily="ui-monospace">{i+1}</text>
            <text x="0" y="90" textAnchor="middle" fill="#ffffffb0" fontSize="8.5">{p.l}</text>
          </g>
        ))}
      </g>
    </svg>
  );
}

export function VisualRegard() {
  return (
    <svg viewBox="0 0 480 260" className="w-full h-auto" role="img" aria-label="Placement du regard en conduite">
      <rect width="480" height="260" fill={bg} />
      <text x="240" y="30" textAnchor="middle" fill="#0ea5e9" fontSize="10" fontFamily="ui-monospace" letterSpacing="2">REGARD LOIN · CONDUIRE TÔT</text>
      {/* Route en perspective */}
      <path d="M 100 230 L 200 90 L 280 90 L 380 230 Z" fill="#151517" stroke="#2a2a2e" />
      <line x1="240" y1="230" x2="240" y2="90" stroke="#ffffff30" strokeDasharray="4 6" />
      {/* Zones de regard */}
      <g>
        <ellipse cx="240" cy="100" rx="60" ry="12" fill="#0ea5e9" opacity="0.35" />
        <text x="240" y="80" textAnchor="middle" fill="#7dd3fc" fontSize="10" fontWeight="bold" fontFamily="ui-monospace">200-300 m</text>
        <text x="240" y="107" textAnchor="middle" fill="#ffffff" fontSize="9">Anticipation</text>
      </g>
      <g>
        <ellipse cx="240" cy="150" rx="80" ry="10" fill="#f59e0b" opacity="0.25" />
        <text x="240" y="155" textAnchor="middle" fill="#fbbf24" fontSize="9">Analyse</text>
      </g>
      <g>
        <ellipse cx="240" cy="200" rx="120" ry="10" fill="#dc2626" opacity="0.2" />
        <text x="240" y="205" textAnchor="middle" fill="#f87171" fontSize="9">Correction (dernier recours)</text>
      </g>
    </svg>
  );
}

export function VisualTrajectoire() {
  return (
    <svg viewBox="0 0 480 260" className="w-full h-auto" role="img" aria-label="Trajectoire idéale dans un virage">
      <rect width="480" height="260" fill={bg} />
      <text x="240" y="30" textAnchor="middle" fill="#10b981" fontSize="10" fontFamily="ui-monospace" letterSpacing="2">TRAJECTOIRE · LARGE-CORDE-LARGE</text>
      {/* Route courbe */}
      <path d="M 50 200 Q 240 60 430 200" stroke="#3f3f46" strokeWidth="60" fill="none" />
      <path d="M 50 200 Q 240 60 430 200" stroke="#ffffff20" strokeWidth="1" fill="none" strokeDasharray="6 8" />
      {/* Bonne trajectoire */}
      <path d="M 60 195 Q 240 130 420 195" stroke="#10b981" strokeWidth="3" fill="none" strokeLinecap="round" />
      <text x="80" y="180" fill="#34d399" fontSize="10" fontWeight="bold">1. Entrée large</text>
      <text x="215" y="155" fill="#34d399" fontSize="10" fontWeight="bold">2. Corde apex</text>
      <text x="330" y="180" fill="#34d399" fontSize="10" fontWeight="bold">3. Sortie large</text>
      {/* Mauvaise trajectoire */}
      <path d="M 60 210 Q 240 210 420 175" stroke="#ef4444" strokeWidth="2" fill="none" strokeDasharray="4 4" opacity="0.8" />
      <text x="380" y="245" fill="#ef4444" fontSize="9" opacity="0.85">✗ Trajectoire tendue = perte adhérence</text>
    </svg>
  );
}

export function VisualPlacement() {
  return (
    <svg viewBox="0 0 480 260" className="w-full h-auto" role="img" aria-label="Placement latéral sur la chaussée">
      <rect width="480" height="260" fill={bg} />
      <text x="240" y="30" textAnchor="middle" fill="#a855f7" fontSize="10" fontFamily="ui-monospace" letterSpacing="2">PLACEMENT · DISTANCES LATÉRALES</text>
      {/* Route */}
      <rect x="60" y="70" width="360" height="150" fill="#151517" />
      <line x1="60" y1="145" x2="420" y2="145" stroke="#f59e0b" strokeWidth="2" strokeDasharray="16 12" />
      {/* Voiture ego */}
      <rect x="180" y="105" width="60" height="30" rx="4" fill="#dc2626" />
      <text x="210" y="123" textAnchor="middle" fill="#ffffff" fontSize="9" fontWeight="bold">MOI</text>
      {/* Cycliste */}
      <circle cx="120" cy="120" r="10" fill="#0ea5e9" />
      <text x="120" y="145" textAnchor="middle" fill="#7dd3fc" fontSize="9">Cycliste</text>
      {/* Cote 1.5m */}
      <line x1="130" y1="120" x2="180" y2="120" stroke="#a855f7" strokeWidth="1.5" markerEnd="url(#arr)" markerStart="url(#arr)" />
      <text x="155" y="112" textAnchor="middle" fill="#c084fc" fontSize="10" fontWeight="bold">1.5 m mini</text>
      {/* Piéton */}
      <circle cx="300" cy="200" r="8" fill="#10b981" />
      <text x="300" y="222" textAnchor="middle" fill="#34d399" fontSize="9">Piéton</text>
      <line x1="240" y1="200" x2="292" y2="200" stroke="#a855f7" strokeWidth="1.5" markerEnd="url(#arr)" markerStart="url(#arr)" />
      <text x="266" y="192" textAnchor="middle" fill="#c084fc" fontSize="10" fontWeight="bold">1 m mini (ville)</text>
      <defs><marker id="arr" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="6" markerHeight="6" orient="auto"><path d="M0,0 L10,5 L0,10 z" fill="#a855f7" /></marker></defs>
    </svg>
  );
}

export function VisualPartage() {
  return (
    <svg viewBox="0 0 480 260" className="w-full h-auto" role="img" aria-label="Partage de la route avec les usagers vulnérables">
      <rect width="480" height="260" fill={bg} />
      <text x="240" y="30" textAnchor="middle" fill="#dc2626" fontSize="10" fontFamily="ui-monospace" letterSpacing="2">USAGERS VULNÉRABLES · 45% DES TUÉS</text>
      {/* 4 vignettes */}
      {[
        { x: 90, l: 'Piéton', c: '#10b981', d: 'Priorité passage', icon: 'M0,-8 A5,5 0 1 0 0.01,-8 M-4,-2 L4,-2 L4,8 L2,8 L2,4 L-2,4 L-2,8 L-4,8 Z' },
        { x: 200, l: 'Cycliste', c: '#0ea5e9', d: '1.5 m écart', icon: 'M-8,4 A5,5 0 1 0 -7.9,4 M8,4 A5,5 0 1 0 8.01,4 M-5,4 L2,-4 L5,-4' },
        { x: 310, l: 'Moto', c: '#f59e0b', d: 'Angle mort +' , icon: 'M-6,4 A4,4 0 1 0 -5.99,4 M6,4 A4,4 0 1 0 6.01,4 M-6,4 L6,4 M-2,-4 L2,-4 L4,4' },
        { x: 420, l: 'PL', c: '#a855f7', d: '4 angles morts', icon: 'M-14,4 L14,4 L14,-8 L-14,-8 Z M-10,4 A2,2 0 1 0 -9.99,4 M10,4 A2,2 0 1 0 10.01,4' },
      ].map((v, i) => (
        <g key={i} transform={`translate(${v.x}, 130)`}>
          <rect x="-40" y="-30" width="80" height="90" rx="10" fill="#151517" stroke={v.c} strokeOpacity="0.4" />
          <g transform="translate(0, 10)" fill="none" stroke={v.c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d={v.icon} />
          </g>
          <text y="42" textAnchor="middle" fill="#ffffff" fontSize="10" fontWeight="bold">{v.l}</text>
          <text y="55" textAnchor="middle" fill={v.c} fontSize="8.5">{v.d}</text>
        </g>
      ))}
    </svg>
  );
}

export function VisualIntersections() {
  return (
    <svg viewBox="0 0 480 260" className="w-full h-auto" role="img" aria-label="Types d'intersections">
      <rect width="480" height="260" fill={bg} />
      <text x="240" y="30" textAnchor="middle" fill="#f59e0b" fontSize="10" fontFamily="ui-monospace" letterSpacing="2">4 TYPES D&apos;INTERSECTIONS</text>
      {[
        { x: 80, l: 'STOP', sub: 'Arrêt total', c: '#dc2626', shape: 'octogon' },
        { x: 200, l: 'CÉDEZ', sub: 'Ralentir', c: '#f59e0b', shape: 'tri' },
        { x: 320, l: 'FEUX', sub: 'Vert/Orange/Rouge', c: '#10b981', shape: 'circle' },
        { x: 440, l: 'PRIORITÉ', sub: 'Losange jaune', c: '#facc15', shape: 'diamond' },
      ].map((n, i) => (
        <g key={i} transform={`translate(${n.x}, 130)`}>
          {n.shape === 'octogon' && (<polygon points="-25,-8 -8,-25 8,-25 25,-8 25,8 8,25 -8,25 -25,8" fill={n.c} />)}
          {n.shape === 'tri' && (<polygon points="0,-25 25,20 -25,20" fill="#fff" stroke={n.c} strokeWidth="4" />)}
          {n.shape === 'circle' && (<><circle r="24" fill="#151517" stroke={n.c} strokeWidth="2" /><circle cx="0" cy="-10" r="5" fill="#dc2626" /><circle cx="0" cy="2" r="5" fill="#f59e0b" opacity="0.4" /><circle cx="0" cy="14" r="5" fill="#10b981" opacity="0.4" /></>)}
          {n.shape === 'diamond' && (<polygon points="0,-25 25,0 0,25 -25,0" fill={n.c} />)}
          {n.shape === 'octogon' && <text y="4" textAnchor="middle" fill="#ffffff" fontSize="10" fontWeight="bold">STOP</text>}
          <text y="48" textAnchor="middle" fill="#ffffff" fontSize="10" fontWeight="bold">{n.l}</text>
          <text y="61" textAnchor="middle" fill="#ffffffa0" fontSize="8.5">{n.sub}</text>
        </g>
      ))}
    </svg>
  );
}

export function VisualControles() {
  return (
    <svg viewBox="0 0 480 260" className="w-full h-auto" role="img" aria-label="Contrôles rétros et angles morts">
      <rect width="480" height="260" fill={bg} />
      <text x="240" y="30" textAnchor="middle" fill="#0ea5e9" fontSize="10" fontFamily="ui-monospace" letterSpacing="2">MMV · MIROIR–MANŒUVRE–VÉRIFICATION</text>
      {/* Vue de dessus voiture */}
      <g transform="translate(240, 140)">
        <rect x="-30" y="-45" width="60" height="90" rx="10" fill="#151517" stroke="#dc2626" strokeWidth="2" />
        <rect x="-25" y="-38" width="50" height="18" rx="4" fill="#dc2626" opacity="0.3" />
        <text y="8" textAnchor="middle" fill="#ffffff" fontSize="9" fontWeight="bold">MOI</text>
        {/* Zones angles morts */}
        <path d="M -30 -40 L -100 -70 L -100 30 L -30 -10 Z" fill="#dc2626" opacity="0.18" />
        <path d="M 30 -40 L 100 -70 L 100 30 L 30 -10 Z" fill="#dc2626" opacity="0.18" />
        <text x="-70" y="-25" textAnchor="middle" fill="#f87171" fontSize="9" fontWeight="bold">ANGLE MORT</text>
        <text x="70" y="-25" textAnchor="middle" fill="#f87171" fontSize="9" fontWeight="bold">ANGLE MORT</text>
        {/* Rétros */}
        <circle cx="-35" cy="-30" r="5" fill="#0ea5e9" />
        <circle cx="35" cy="-30" r="5" fill="#0ea5e9" />
        <circle cx="0" cy="-40" r="5" fill="#0ea5e9" />
        <text x="0" y="-52" textAnchor="middle" fill="#7dd3fc" fontSize="8">Rétro intérieur</text>
      </g>
      <text x="240" y="230" textAnchor="middle" fill="#ffffffa0" fontSize="10">Toujours coup d&apos;œil épaule avant chaque manœuvre</text>
    </svg>
  );
}

export function VisualAllure() {
  return (
    <svg viewBox="0 0 480 260" className="w-full h-auto" role="img" aria-label="Distance de sécurité et vitesse">
      <rect width="480" height="260" fill={bg} />
      <text x="240" y="30" textAnchor="middle" fill="#10b981" fontSize="10" fontFamily="ui-monospace" letterSpacing="2">DISTANCE DE SÉCURITÉ · RÈGLE DES 2 SECONDES</text>
      {/* Voitures */}
      <g transform="translate(60, 130)">
        <rect x="0" y="0" width="70" height="35" rx="6" fill="#3f3f46" />
        <text x="35" y="21" textAnchor="middle" fill="#ffffff" fontSize="10">Devant</text>
      </g>
      <g transform="translate(340, 130)">
        <rect x="0" y="0" width="70" height="35" rx="6" fill="#dc2626" />
        <text x="35" y="21" textAnchor="middle" fill="#ffffff" fontSize="10" fontWeight="bold">MOI</text>
      </g>
      {/* Espace 2 sec */}
      <line x1="135" y1="147" x2="335" y2="147" stroke="#10b981" strokeWidth="2" markerEnd="url(#a2)" markerStart="url(#a2)" />
      <rect x="180" y="115" width="120" height="30" rx="6" fill="#10b981" opacity="0.2" stroke="#10b981" />
      <text x="240" y="135" textAnchor="middle" fill="#34d399" fontSize="12" fontWeight="bold">2 secondes</text>
      <text x="240" y="185" textAnchor="middle" fill="#ffffffa0" fontSize="10">≈ 39 m à 70 km/h · 73 m à 130 km/h</text>
      <text x="240" y="205" textAnchor="middle" fill="#facc15" fontSize="9">Pluie / brouillard : DOUBLER la distance</text>
      <defs><marker id="a2" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="6" markerHeight="6" orient="auto"><path d="M0,0 L10,5 L0,10 z" fill="#10b981" /></marker></defs>
    </svg>
  );
}

export function VisualDepassements() {
  return (
    <svg viewBox="0 0 480 260" className="w-full h-auto" role="img" aria-label="Phases d'un dépassement">
      <rect width="480" height="260" fill={bg} />
      <text x="240" y="30" textAnchor="middle" fill="#a855f7" fontSize="10" fontFamily="ui-monospace" letterSpacing="2">DÉPASSEMENT · VOIR-ÊTRE VU-DÉCIDER</text>
      {/* Route */}
      <rect x="30" y="100" width="420" height="100" fill="#151517" />
      <line x1="30" y1="150" x2="450" y2="150" stroke="#f59e0b" strokeWidth="2" strokeDasharray="14 10" />
      {/* Véhicule dépassé */}
      <rect x="200" y="160" width="50" height="26" rx="4" fill="#3f3f46" />
      <text x="225" y="177" textAnchor="middle" fill="#ffffff" fontSize="8">Dépassé</text>
      {/* Trajectoire dépassement */}
      <path d="M 60 175 Q 130 175 155 130 Q 220 105 275 105 Q 330 105 355 130 Q 400 175 440 175" stroke="#a855f7" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      {/* Étapes */}
      {[{x:80, l:'1', d:'Cligno'}, {x:180, l:'2', d:'Déboîter'}, {x:280, l:'3', d:'Dépasser'}, {x:380, l:'4', d:'Se rabattre'}].map((s, i) => (
        <g key={i}>
          <circle cx={s.x} cy={i === 2 ? 105 : 130} r="10" fill="#a855f7" />
          <text x={s.x} y={(i === 2 ? 105 : 130) + 4} textAnchor="middle" fill="#ffffff" fontSize="10" fontWeight="bold">{s.l}</text>
          <text x={s.x} y={i === 2 ? 88 : 113} textAnchor="middle" fill="#c084fc" fontSize="9">{s.d}</text>
        </g>
      ))}
      <text x="240" y="230" textAnchor="middle" fill="#facc15" fontSize="10">Visibilité 400 m minimum à 90 km/h</text>
    </svg>
  );
}

export const VISUAL_MAP = {
  mecanique: VisualMecanique,
  synchronisation: VisualSynchronisation,
  regard: VisualRegard,
  trajectoire: VisualTrajectoire,
  placement: VisualPlacement,
  partage: VisualPartage,
  intersections: VisualIntersections,
  'controles-retros': VisualControles,
  allure: VisualAllure,
  depassements: VisualDepassements,
};
